import styled from "styled-components";
import { Link } from "react-router-dom";
import { getFontSize } from "utils/text-styles";

export const Nav = styled.nav`
  background-color: ${(props) =>
    props.theme.theme.NAVBAR.BACKGROUND} !important;
  transition: background-color 0.5s ease-in-out;
  box-shadow: none !important;

  .navbar-brand-cm {
    font-size: 1rem;
    font-weight: 500;
    color: #fff;
  }

  .toolbar {
    width: auto !important;
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .dropdown-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dropdown {
    width: auto !important;
  }

  .dropdown-menu {
    text-align: center;

    @media (max-width: 768px) {
      text-align: left;
    }
  }

  .dropdown-item {
    padding: 10px !important;
    &:hover {
      background-color: none;
    }
  }

  .btn-cu {
    display: flex;
    justify-content: center;
    padding: 8px 18px 8px 15px !important;
    background-color: #0f69c4;
    font-family: Roboto, sans-serif;
    font-size: ${(props) =>
      getFontSize(props.theme.fontSize, "link")} !important;
    font-weight: 400;
    line-height: 1.6em;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-radius: 0;

    &:focus {
      background-color: #0c549c;
      color: #fff;
      outline: 1px dashed #000;
    }

    .cl-claveunica {
      color: #fff;
      font-size: ${(props) =>
        getFontSize(props.theme.fontSize, "link")} !important;
      font-weight: 500;
      margin-right: 10px;
      float: left;
      margin-top: 3px;
      width: 24px;
      height: 24px;
      display: inline;
    }

    .btn-s {
      width: 130px;
      min-width: 130px;
      height: 36px;
      padding: 8px 10px !important;
      font-size: ${(props) =>
        getFontSize(props.theme.fontSize, "link")} !important;

      .cl-claveunica {
        width: 20px;
        height: 20px;
        background-size: 20px 20px;
      }
    }

    .btn-m {
      width: 160px;
      min-width: 160px;
      height: 42px;
      padding: 8px 18px 8px 15px !important;
      font-size: ${(props) =>
        getFontSize(props.theme.fontSize, "text")} !important;
      line-height: 1.6em;

      .cl-claveunica {
        display: inline-block;
        width: 24px;
        height: 24px;
        background-size: 24px 24px;
      }
    }

    .btn-l {
      width: 180px;
      min-width: 180px;
      height: 48px;
      padding: 11px 18px !important;
      font-size: ${(props) =>
        getFontSize(props.theme.fontSize, "subtitle")} !important;
      .cl-claveunica {
        width: 26px;
        height: 26px;
        background-size: 26px 26px;
      }
    }

    .btn-fw {
      max-width: 550px;
      width: 100%;
      display: flex;
      justify-content: center;
    }

    .texto {
      padding-left: 3px;
      text-decoration: underline;
    }
  }
`;

export const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const NavbarBrand = styled.a`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.theme.TEXT.NAVLINK} !important;
`;

export const NavbarToggler = styled.button`
  background-color: transparent;
  border: none;
`;

export const NavbarToolbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 991.98px) {
    margin-top: 2.5rem;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    height: 100%;
  }
`;

export const NavbarToolbarButton = styled.button`
  background-color: transparent;
  border: none;
  color: ${(props) => props.theme.theme.TEXT.NAVLINK} !important;

  &:hover {
    color: ${(props) => props.theme.theme.COLOR_ACCENT} !important;
  }

  @media (max-width: 768px) {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
`;

export const NavbarToolbarGroup = styled.div`
  display: flex !important;
  align-items: center;
`;

export const Navbar = styled.ul`
  display: flex;
  list-style: none;
  text-align: center;
  padding: 1rem 0;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    list-style: none;
  }
`;

export const NavItem = styled.li`
  margin: 0;
  font-size: ${(props) => getFontSize(props.theme.fontSize, "link")} !important;

  &:focus {
    background-color: transparent !important;
    outline: none;
  }

  .btn-cu {
    display: flex;
    align-items: center;
    background-color: ${(props) => props.theme.theme.COLOR_ACCENT};
    color: ${(props) => props.theme.theme.TEXT.LIGHT} !important;
    border: 1px solid ${(props) => props.theme.theme.DIVIDER_COLOR};
    cursor: pointer;
    text-decoration: none;

    .cl-claveunica {
      margin: 0;
      display: flex;
      align-items: center;
    }
  }
`;

export const NavLink = styled(Link)`
  color: ${(props) => props.theme.theme.TEXT.NAVLINK} !important;
  text-decoration: none;
  font-size: ${(props) => getFontSize(props.theme.fontSize, "link")} !important;

  &:focus {
    background-color: transparent !important;
    outline: none;
  }

  a {
    font-size: ${(props) =>
      getFontSize(props.theme.fontSize, "link")} !important;
  }
  line-height: 1;
`;
